import EventEmitter from '../../helpers/EventEmmiter';
import {REGEX_ROOM_URL} from "a_root-folder/constants";

require('./chat.scss');

export default class E3ChatService extends EventEmitter {
    constructor() {
        super()
        this._chat = {};
        this._chat.input = null;
        this._chat.messages = null;
        this._chat.container = null;
    }

    init(container) {
        this._container = container;
    }

    show() {
        if (this._chat.container) {
            this._chat.container.classList.remove('hidden');
            return
        }
        this._chat.container = this._chatBlock();
        this._container.appendChild(this._chat.container);
    }

    hide() {
        if (!this._chat.container) return
        this._chat.container.classList.add('hidden');
    }

    _chatBlock() {
        var elem = document.createElement('form');
        elem.setAttribute('id', 'chat');

        var elemDiv = document.createElement('div');
        elemDiv.setAttribute('id', 'input');
        elemDiv.classList.add('triangle');
        elemDiv.classList.add('right');

        var chatInput = document.createElement('INPUT');
        chatInput.setAttribute("id", "messageInput");
        chatInput.setAttribute("type", "text");
        chatInput.setAttribute("placeholder", "");
        chatInput.setAttribute("autocomplete", "off");
        elem.onsubmit = this._sendMsg.bind(this);
        this._chat.input = chatInput;

        var chatMessage = document.createElement('div');
        chatMessage.setAttribute('id', 'messages');
        this._chat.messages = chatMessage;

        var sendButton = document.createElement('input');
        sendButton.setAttribute('id', 'chat-send');
        sendButton.setAttribute('type', 'submit');
        sendButton.setAttribute('value', '➤');

        elemDiv.appendChild(chatInput);
        elemDiv.appendChild(sendButton);
        elem.appendChild(chatMessage);

        elem.appendChild(elemDiv);

        chatInput.addEventListener('focus', _onChatFocus);
        chatInput.addEventListener('blur', _onChatBlur);

        function _triggerDocumentFocus(e) {
            chatInput.blur();
        }

        function _preventFormFocus(e) {
            e.stopImmediatePropagation();
        }

        function _onChatFocus() {
            document.body.addEventListener('touchstart', _triggerDocumentFocus);
            elem.addEventListener('touchstart', _preventFormFocus);
        }

        function _onChatBlur() {
            document.body.removeEventListener('touchstart', _triggerDocumentFocus);
            elem.removeEventListener('touchstart', _preventFormFocus);
        }

        return elem;
    }

    addMsg(obj, ownerMsg) {
        this._listenerForE3liveUrl(obj);

        this._chat.messages.appendChild(this._createItemForMsg(obj.message.data, ownerMsg));
        if (this._chat.messages.getElementsByClassName('message').length > 4) {
            this._chat.messages.removeChild(this._chat.messages.getElementsByClassName('message')[0]);
        }
        document.getElementById('messages').scrollTop = document.getElementById('messages').scrollHeight
    }

    _listenerForE3liveUrl(obj){
        const msg = obj.message.data.msg;
        if(msg.match(REGEX_ROOM_URL)){
            const url = msg.match(REGEX_ROOM_URL)[0];
            window.location.href = url;
        }
    }

    _sendMsg(e, msg) {
        var value = this._chat.input.value || msg;
        e.preventDefault();
        if ((typeof e.keyCode == 'undefined' || e.keyCode == 13) && value && value != '') {
            this._fireEvent('e3-chat-send', value);
            this._chat.input.value = '';
            this._chat.input.focus();
        }
    };

    _createItemForMsg(data, ownerMsg) {
        var message = document.createElement('div');
        var block = document.createElement('div');
        message.classList.add('message');
        block.classList.add('triangle');
        if (ownerMsg) {
            block.classList.add('right');
            message.classList.add('right');
        } else {
            block.classList.add('left');
            message.classList.add('left');
        }

        if (data.msg) {
            var urls = [];
            data.msg = data.msg.replace(/[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi, function (url) {
                urls.push('<a href="' + url + '" target="_blank">' + url + '</a>');
                return 'e3urlreplace' + (urls.length - 1) + '_';
            });
            data.msg = data.msg.replace(/([0-9\-\+]{6,})/gi, function (tel) {
                return '<a href="tel:' + tel + '" target="_blank">' + tel + '</a>';
            });
            data.msg = data.msg.replace(/e3urlreplace\d+_/gi, function (str, group) {
                return urls[+group];
            });
        }

        block.innerHTML = data.msg;

        message.appendChild(block);

        return message;

    }
}
